import { escapeHtml } from "../string/escape-html.js";
//#region src/dom/attributes.ts
/** Capture authored values for the selected attributes. */
function snapshotAttributes(element, names) {
	return [...names].map((name) => ({
		name,
		value: element.getAttribute(name)
	}));
}
/** Restore a snapshot created by `snapshotAttributes`. */
function restoreAttributes(element, snapshot) {
	for (const { name, value } of snapshot) if (value === null) element.removeAttribute(name);
	else element.setAttribute(name, value);
}
/** Convert a NamedNodeMap to a plain object. */
function namedNodeMapToObject(namedNodeMap) {
	const obj = {};
	for (const attr of namedNodeMap) obj[attr.name] = attr.value;
	return obj;
}
/** Helper function to serialize attributes into a string. */
function serializeAttributes(attrs) {
	let html = "";
	for (const key in attrs) {
		const value = attrs[key];
		if (value === "") html += ` ${key}`;
		else html += ` ${key}="${escapeHtml(value)}"`;
	}
	return html;
}
//#endregion
export { namedNodeMapToObject, restoreAttributes, serializeAttributes, snapshotAttributes };

//# sourceMappingURL=attributes.js.map